import MuiAccordion from "@mui/material/Accordion";
import { styled } from "@mui/system";
import { MDXRemote } from "next-mdx-remote";
import { useEffect, useState } from "react";
import { convertMDX } from "utils/mdx";

import { AccordionSummary } from "../onboardingSections/inputs";

import styles from "@/styles/document.module.scss";

const FAQ = ({ data }) => {
  const [state, setState] = useState(null);
  const [expanded, setExpanded] = useState(false);
  const [subAccordionExpanded, setSubAccordionExpanded] = useState(false);
  useEffect(() => {
    async function setData() {
      const source = data.faqs.data[expanded]?.attributes
        ? data.faqs.data[expanded].attributes.Questions.length > 1
          ? data.faqs.data[expanded].attributes.Questions[
              subAccordionExpanded
            ]?.Answer.replace("<br>", " ")
          : data.faqs.data[expanded].attributes.Questions[0]?.Answer.replace(
              "<br>",
              " ",
            )
        : "";
      const mdxSource = await convertMDX(source, false);
      setState(mdxSource);
    }
    if (expanded !== false) {
      setData();
    }
    if (data.faqs.data[0].attributes.Questions.length <= 1) {
      setData();
    }
  }, [subAccordionExpanded, data.faqs.data, expanded]);

  useEffect(() => {
    // Make sure all the subAccordion are collapsed when parent accordion is expanded
    setSubAccordionExpanded(false);
  }, [expanded]);

  const DocsAccordion = styled(props => (
    <MuiAccordion disableGutters elevation={0} {...props} />
  ))(({ theme }) => ({
    borderBottom: "1px solid #C4C4C4",
    backgroundColor: "",
    width: "100%",
    borderRadius: "0px !important",
    "&:before": {
      display: "none",
    },
  }));

  const handleChange = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const handleSubAccordionChange = panel => (event, newExpanded) => {
    setSubAccordionExpanded(newExpanded ? panel : false);
  };

  return (
    <div className="max-w-1420 mx-auto w-full p-7 md:p-20">
      {data.faqs.data.map((v, i) => (
        <DocsAccordion
          key={i}
          expanded={expanded === i}
          onChange={handleChange(i)}
        >
          <AccordionSummary aria-controls={`panel${i}`} id={`panel${i}`}>
            <p className={styles.accordionTitle}>{v.attributes.Title}</p>
          </AccordionSummary>
          <div className={styles.content}>
            {v.attributes.Questions.length > 0 &&
              v.attributes.Questions.map((q, l) => (
                <DocsAccordion
                  key={l}
                  expanded={subAccordionExpanded === l}
                  onChange={handleSubAccordionChange(l)}
                >
                  <AccordionSummary
                    aria-controls={`panel${l}`}
                    id={`panel${l}`}
                  >
                    <p className={styles.accordionTitle}>{q.Question}</p>
                  </AccordionSummary>
                  <div className={styles.content}>
                    {state === null ? null : <MDXRemote {...state} />}
                  </div>
                </DocsAccordion>
              ))}
          </div>
        </DocsAccordion>
      ))}
    </div>
  );
};

export default FAQ;
